wp.blocks.registerBlockVariation( 'core/group', {
    name: 'full-width-group',
    title: 'Full width group',
    attributes: {
        align: 'full',
    },
} );

wp.blocks.registerBlockVariation( 'core/button', {
    name: 'button-with-icon',
    title: 'Button with icon',
    innerBlocks: [
        [ 'core/image' ]	]
} );

